import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Success from './pages/Success';
import './App.css';

function App() {
    return (
        <div className="App">
        <Routes>
            <Route path="/LP1" element={<Home />} />
            <Route path="/LP1/thankyou" element={<Success />} />
        </Routes>
        </div>
    );
}

export default App;
